import { Shop } from "../filter/shop";
import { Interest } from "../../entities";

/** Class that references a shop product. */
export class imagesUrl {
  public id: number;
  public url: string;
  public extension: string;

  constructor(emptyString = "", id = NaN) {
    this.extension = emptyString;
    this.url = emptyString;
    this.id = id;
  }
}

export class Product {
  /** Product ID. */
  public id: number;

  /** Code of product. */
  public code: string;

  /** Name of product. */
  public name: string;

  /** Description of product. */
  public description: string;

  /** Informs if the product is already published in the shop. */
  public isActive: boolean;

  /** Image extension. Eg: png, jpeg*/
  public imageExtension: string;

  /** Product image url. */
  public imagesUrl: Array<imagesUrl>;

  /** Price of product. */
  public decoins: number;

  /** Quantity of products. */
  public stock: number;

  /** Date of the last time the product was updated. */
  public lastChange: string;

  /** Shop linked to the product. */
  public shop: Shop;

  /** Quantity of products. Used to check the amount of products added in the bag. */
  public quantity: number;

  constructor(
    id = NaN,
    code = "",
    name = "",
    description = "",
    isActive = true,
    imageExtension = "",
    imagesUrl = new Array<imagesUrl>(),
    decoins = NaN,
    stock = NaN,
    lastChange = "",
    shops = new Shop(),
    quantity = NaN
  ) {
    this.id = id;
    this.code = code;
    this.name = name;
    this.description = description;
    this.isActive = isActive;
    this.imageExtension = imageExtension;
    this.imagesUrl = imagesUrl;
    this.decoins = decoins;
    this.stock = stock;
    this.lastChange = lastChange;
    this.shop = shops;
    this.quantity = quantity;
  }
}
